import { Directive, HostListener, inject } from '@angular/core';
import { FormControl, NgControl } from '@angular/forms';

/**
 * Replaces pasted content with a comma-separated string list, keeping caret position consistent.
 * Applies only to matInput-bound inputs.
 */
@Directive({
  selector: 'input[matInput][slcInputPasteToStringList]',
})
export class SliceInputPasteToStringListDirective {
  private ngControl = inject(NgControl, { self: true, optional: true })!;

  @HostListener('paste', ['$event'])
  onPaste(event: ClipboardEvent) {
    event.preventDefault();

    if (!this.ngControl?.control?.setValue) {
      return;
    }

    // Get clipboard data
    const clipboardData = event.clipboardData?.getData('text');
    if (!clipboardData) {
      return;
    }

    // Split by common separators: tabs, newlines, commas, semicolons, pipes, and whitespace
    const values = clipboardData
      .split(/[\t\n\r,;|\s]+/)
      .map((v) => v.trim())
      .filter((v) => v.length > 0);

    if (values.length === 0) {
      return;
    }

    // Get the current input element and form control value
    const input = event.target as HTMLInputElement;
    const currentValue = this.ngControl.control?.value || '';

    // Handle selection: replace selected text or insert at cursor
    const start = input.selectionStart || 0;
    const end = input.selectionEnd || 0;

    // Build new value by replacing selection with comma-separated values
    const before = currentValue.substring(0, start);
    const after = currentValue.substring(end);
    const pastedValues = values.join(', ');
    const newValue = before + pastedValues + after;

    // Update form control
    (this.ngControl.control as FormControl).setValue(newValue);

    // Set cursor position after pasted conten
    const newCursorPos = start + pastedValues.length;
    setTimeout(() => {
      input.setSelectionRange(newCursorPos, newCursorPos);
    });
  }
}
